export default __webpack_public_path__ + "static/media/7007BLEU.6b5f17cd.pdf";